import axios from "@/widgets/shared/utils/axios-instance";

export const types = {
};

export function state() {
  return {
  };
}

export const mutations = {
};

export const actions = {
  async fetchById({ commit }, { eventId, componentId, speakerId }) {
    return axios.get(`events/${eventId}/components/${componentId}/speaker/${speakerId}`);
  },
};

export const getters = {
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
